import CommunicationStatusField from "./communication-status-field";
import CommunicationChangesField from "./communication-changes-field";
import CommunicationActionField from "./communication-action-field";
import CommunicationInfoField from "./communication-info-field";
import CommunicationQuestionsField from "./communication-questions-field";
import CommunicationNextStepField from "./communication-next-step-field";
import CommunicationOverviewField from "./communication-overview-field";
import CommunicationReadingPane from "./communication-reading-pane";
import CommunicationAiParserField from "./communication-ai-parser-field";

const CommunicationFields = {
  Status: CommunicationStatusField,
  Changes: CommunicationChangesField,
  Action: CommunicationActionField,
  Info: CommunicationInfoField,
  Questions: CommunicationQuestionsField,
  NextStep: CommunicationNextStepField,
  Overview: CommunicationOverviewField,
  AiParser: CommunicationAiParserField,
  ReadingPane: CommunicationReadingPane,
};

export default CommunicationFields;
